// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-container {
  display: flex;
  flex-direction: column; /* Stack children vertically */
  justify-content: center; /* Center vertically */
  align-items: center; /* Center horizontally */
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
  gap: 40px; /* Adds consistent spacing between child elements */
}

.payment-card {
  width: 70%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 25px;
  font-family: Arial, sans-serif;
}

.payment-header {
  margin-bottom: 20px;
}

.payment-amount {
  margin-bottom: 15px;
}

.amount-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 16px;
}

.amount-row span:last-child {
  font-weight: bold;
}

.payment-secured {
  font-size: 16px;
  color: #666;
  text-align: right;
}

.divider {
  height: 1px;
  background-color: #eee;
  margin: 20px 0;
}

.payment-method-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.payment-methods {
  margin-bottom: 25px;
}

.payment-form {
  margin-top: 20px;
}

.form-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.card-details {
  display: flex;
  gap: 15px;
  margin-top: 15px;
}

.detail-group {
  flex: 1 1;
  margin-bottom: 50px;
}

.detail-group label {
  display: block;
  font-size: 14px;
  margin-bottom: 5px;
  color: #666;
}

.input-frame {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  height: 40px;
}

.save-card {
  display: flex;
  align-items: center;
  margin: 20px 0;
  font-size: 14px;
}

.save-card input {
  margin-right: 10px;
}

.pay-button {
  width: 100%;
  background-color: #002b5b;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}

.pay-button:hover {
  background-color: #004494;
}

#paygreen-container,
#paygreen-methods-container,
#paygreen-pan-frame,
#paygreen-cvv-frame,
#paygreen-exp-frame {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin-bottom: 16px;
}

#paygreen-pan-frame {
  margin-bottom: 15px;
}

.paygreen-pan-frame,
.paygreen-cvv-frame,
.paygreen-exp-frame {
  background-color: rgb(243, 243, 243);
  padding: 0 0.5rem;
  border: none !important;
  margin-bottom: 50px;
}

.paygreen-pan-frame:hover,
.paygreen-cvv-frame:hover,
.paygreen-exp-frame:hover {
  border-bottom: 1px solid #5B3EFF !important;
}

.text-xl-semibold {
  color: #191919;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
}

/* Style pour le texte normal */
.text-sm-regular {
  color: var(--text-secondary-color, #37373b);
  font-family: var(--Typography-font-family, montserrat);
  font-size: var(--Typography-Size-Text-sm, 14px);
  font-style: normal;
  font-weight: var(--Typography-font-weight-regular, 400);
  line-height: var(--Typography-line-height-Text-sm, 20px);
}

/* Style pour les mots en semi-bold */
.text-sm-semibold {
  color: var(--text-secondary-color, #37373b);
  font-family: var(--Typography-font-family, montserrat);
  font-size: var(--Typography-Size-Text-sm, 14px);
  font-style: normal;
  font-weight: var(--Typography-font-weight-semibold, 600);
  line-height: var(--Typography-line-height-Text-sm, 20px);
}

.text-input-container {
  display: flex;
  flex-direction: column;
  gap: 8px; /* Space between label and input */
}

.text-label {
  align-self: stretch;
  color: var(--Input-Label-Color-Default, #191919);
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.28px;
}

.text-input {
  display: flex;
  padding: 8px 16px;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--Input-Stroke-Color-Default, #5b3eff);
  background: var(--Input-Background-Color-Default, rgba(91, 62, 255, 0.06));
  color: var(--Input-Text-Color-Default, #191919);
  border-radius: 0;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
}

.text-input::placeholder {
  color: var(--Input-Placeholder-Color-Default, #999999);
  font-weight: 400;
}

.text-input:focus {
  outline: none;
  border-color: var(--Input-Stroke-Color-Default, #5b3eff);
}

.text-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px; /* Space between elements */
}

.email-help-message {
  flex: 1 0;
  color: var(--Input-Help-Color-Default, #37269a);
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 13.6px;
  letter-spacing: 0.24px;
  margin-top: 4px; /* Small space above the help message */
}

.payment-button {
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: var(--button-primaire-background-color-default, #5b3eff);
  border: none;
  color: white;
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: 100%;
}

.payment-button:hover:not(:disabled) {
  background: var(--button-primaire-background-color-hover, #4a32d1);
}

.payment-button:disabled {
  background: var(--button-primaire-background-color-disabled, #cccccc);
  cursor: not-allowed;
  opacity: 0.7;
}

.custom-paygreen-frame {
  margin-bottom: 12px; /* Space between fields */
}

.paygreen-frame {
  width: 100% !important;
  height: 48px !important;
}

.inputs-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.flex.gap-4 {
  gap: 16px;
}

.payment-text {
  align-self: stretch;
  color: var(--text-secondary-color, #37373b);
  text-align: center;
  font-family: var(--Typography-font-family, montserrat);
  font-size: var(--Typography-Size-Text-xs, 12px);
  font-style: normal;
  font-weight: var(--Typography-font-weight-regular, 400);
  line-height: var(--Typography-line-height-Text-xs, 18px);
}

.payment-text strong {
  font-weight: var(--Typography-font-weight-semibold, 600);
}

.auth-title {
  color: var(--text-Display-color, #191919);
  font-family: var(--Typography-font-family, montserrat);
  font-size: var(--Typography-Size-Text-xl, 20px);
  font-weight: var(--Typography-font-weight-semibold, 600);
  line-height: var(--Typography-line-height-Text-xl, 30px);
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.auth-title2 {
  color: var(--text-Display-color, #191919);
  font-family: var(--Typography-font-family, montserrat);
  font-size: var(--Typography-Size-Text-xl, 20px);
  font-weight: var(--Typography-font-weight-semibold, 400);
  line-height: var(--Typography-line-height-Text-xl, 30px);
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.text-info-message {
  flex: 1 0;
  color: var(--text-Display-color, #191919);

  /* Text md/Semibold */
  font-family: var(--Typography-font-family, montserrat);
  font-size: var(--Typography-Size-Text-md, 16px);
  font-style: normal;
  font-weight: var(--Typography-font-weight-semibold, 600);
  line-height: var(--Typography-line-height-Text-md, 24px);
}

.icon-inline {
  width: 20px;
  height: 20px;
  vertical-align: top;
  margin-right: 4px;
}

.label-invoice {
  flex: 1 0;
  color: var(--text-secondary-color, #37373b);

  font-family: var(--Typography-font-family, montserrat);
  font-size: var(--Typography-Size-Text-sm, 14px);
  font-style: normal;
  font-weight: var(--Typography-font-weight-semibold, 600);
  line-height: var(--Typography-line-height-Text-sm, 20px);
}

.custom-checkbox {
  width: 20px;
  height: 20px;
  background: var(--cards-background-hover, #f3f0ff);
  border: 1px solid #d1d5db;
  border-radius: 4px;
  appearance: none;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -10%;
}

/* Bigger violet checkmark */
.custom-checkbox:checked::after {
  content: "✓";
  font-size: 14px; /* Increased from 12px */
  color: #7e5bef;
  position: absolute;
  font-weight: bold; /* Optional: makes checkmark thicker */
}

.label-invoice {
  margin-left: 18px;
  color: var(--text-secondary-color, #37373b);
  font-family: var(--Typography-font-family, montserrat);
  font-size: 14px;
  cursor: pointer;
}

/* Base styles */
.input-group {
  margin-top: 1rem;
  width: 100%;
}

.input-label {
  display: block;
  color: #374151; /* gray-700 */
  margin-bottom: 0.25rem;
}

.text-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db; /* gray-300 */
  border-radius: 0.25rem;
}

.text-input::placeholder {
  color: #9ca3af; /* gray-400 */
}

.error-message {
  color: #dc2626; /* red-600 */
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

/* Error states */
.input-label.error {
  color: #dc2626; /* red-600 */
}

.text-input.input-error {
  border-color: #dc2626; /* red-600 */
}

.text-input.input-error::placeholder {
  color: #f87171; /* red-400 */
}

.input-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 4rem;
}

.input-label {
  color: #000; /* Or your preferred label color */
  margin-bottom: 8px;
  font-weight: 500;
}

.styled-input {
  display: flex;
  padding: 8px 16px;
  align-items: center;
  align-self: stretch;
  border: none;
  border-bottom: 1px solid #5b3eff; /* --Input-Stroke-Color-Default */
  background: rgba(91, 62, 255, 0.06); /* --Input-Background-Color-Default */
  outline: none;
  width: 100%;
  color: #37373B;
}

.styled-input::placeholder {
  color: #000; /* Or your preferred placeholder color */
  opacity: 1; /* Ensure full visibility */
}

.paygreen-pan-frame {
  border-bottom: 1px solid #5b3eff !important;
  padding: 4px 16px !important;
  background-color: rgba(91, 62, 255, 0.06) !important;
  width: 100%;
}

.paygreen-cvv-frame,
.paygreen-exp-frame {
  border-bottom: 1px solid #5b3eff !important;
  background-color: rgba(91, 62, 255, 0.06) !important;
  padding: 4px 16px !important;
  margin-top: 4px;
}

.error-title {
  align-self: stretch;
  color: #c40505;
  text-align: center;
  font-family: montserrat, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 8px;
}

.displayed-error-message {
  align-self: stretch;
  color: var(--text-secondary-color, #37373b);
  text-align: center;
  font-family: var(--Typography-font-family, Montserrat), sans-serif;
  font-size: var(--Typography-Size-Text-sm, 14px);
  font-style: normal;
  font-weight: var(--Typography-font-weight-regular, 400);
  line-height: var(--Typography-line-height-Text-sm, 20px);
  width: 100%;
  max-width: 100%;
  margin-bottom: 40px;
}

.displayed-error-message.mb-2 {
  margin-bottom: 8px !important;
}
.displayed-message {
  align-self: stretch;
  color: var(--text-secondary-color, #37373b);

  /* Text sm/Regular */
  font-family: var(--Typography-font-family, Montserrat);
  font-size: var(--Typography-Size-Text-sm, 14px);
  font-style: normal;
  font-weight: var(--Typography-font-weight-regular, 400);
  line-height: var(--Typography-line-height-Text-sm, 20px); /* 142.857% */
}
.image-container {
  width: 72px;
  height: 72px;
  margin-bottom: 40px;
}

.details-header {
  flex: 1 0;
  color: var(--Text-Highlight, #fff);
  font-family: var(--Typography-font-family, Montserrat);
  font-size: var(--Typography-Size-Text-sm, 14px);
  font-style: normal;
  font-weight: var(--Typography-font-weight-semibold, 600);
  line-height: var(--Typography-line-height-Text-sm, 20px);
  background-color: #5b3eff;
  padding: 8px 16px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.details-container {
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 20px;
}

.details-content {
  padding: 16px;
  background-color: white;
}

.custom-button {
  border-radius: 8px;
  background: var(--button-primaire-background-color-default, #5b3eff);
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  color: white;
  font-weight: 600;
  width: 100%;
  transition: background 0.3s ease;
  border: none;
  margin-top: auto;
}

.custom-button:hover {
  background: var(--button-primaire-background-color-default, #5b3eff);
  cursor: pointer;
}

.disabled-button {
  background: var(--button-primaire-background-color-disabled, #cccccc);
  cursor: not-allowed !important;
}

.disabled-button:hover {
  background: var(--button-primaire-background-color-disabled, #cccccc);
  cursor: pointer;
}

.custom-button-text {
  color: var(--button-primaire-content-color-default, #fff);
  text-align: center;
  font-family: var(--Typography-font-family, Montserrat);
  font-size: var(--Typography-Size-Text-lg, 18px);
  font-style: normal;
  font-weight: var(--Typography-font-weight-medium, 500);
  line-height: var(--Typography-line-height-Text-lg, 28px); /* 155.556% */
}

.small-btn {
    width: 270px;
    margin: auto;
}

.charging-containre {
  display: flex;
  max-width: 500px;
  padding: 80px 0px;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  flex: 1 0;
  align-self: stretch;
  border-radius: 8px;
}

.charging-image-container {
  width: 64px;
  height: 64px;
  flex-shrink: 0;
}

.adress__card {
  border: 1px solid var(--Stroke, #191919);
  border-radius: 8px;
  background-color: #FFFFFF;
}

.adress__card__header {
  gap: 8px;
  border-bottom-width: 1px;
  padding: 2px 8px;
  border-bottom: 1px solid var(--Stroke, #191919);
  background: var(--Highlight-color, #5B3EFF);
  color: #FFFFFF;
}

.available__card {
  border: 2px solid var(--Highlight-color, #5B3EFF)
}

.noavailable__card {
  border: 1px solid var(--carte-picto-texte-content-color, #191919)
}

.available__statusBar {
  border-left: 8px solid #61D19D;

}

.noavailable__statusBar {
  border-left: 8px solid #C40505;
}

/* Radio style large comme maquette */
.custom-radio-wrapper {
  position: relative;
  width: 20px;
  height: 20px;
}

.custom-radio-wrapper input[type="radio"] {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.custom-radio {
  width: 20px;
  height: 20px;
  display: inline-block;
  border: 1px solid #5B3EFF; 
  border-radius: 9999px;
  position: absolute;
  top: 0;
  left: 0;
  background: white;
  transition: all 0.2s ease;
}

.custom-radio-wrapper input[type="radio"]:checked + .custom-radio {
  background: #5B3EFF;
  padding: 2px;
  box-shadow: 0 0 0 2px rgba(108, 78, 255, 0.2);
}


.plug__text {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}

.status__text {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}


.text-success-700 {
  color: var(--Colors-Success-700, #37966A);
}

.text-error-700 {
  color: var(--Colors-Error-700, #980404);
}

.pb-75 {
  padding-bottom: 75px;
}

.mt-32 {
  margin-top: 32px;
}

.footer-btn {
  z-index: 1024;
}

.recaptcha-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.recaptcha-container > div {
  transform: scale(0.9);
  transform-origin: 0 0;
  margin-bottom: 8px;
}

@media (min-width: 768px) {
  .recaptcha-container > div {
    transform: scale(1);
  }
}

.styled-input .StripeElement {
  padding: 8px 16px;
  color: #37373B;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  width: 100%;
}

.styled-input .StripeElement--invalid {
  border-bottom: 1px solid red;
}
/* Action secondaire : volontairement plus discrete que .custom-button, pour ne
   pas concurrencer le CTA principal de fin de recharge (deblocage du cable). */
.secondary-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 8px;
  background: transparent;
  border: 1.5px solid var(--button-primaire-background-color-default, #5b3eff);
  color: var(--button-primaire-background-color-default, #5b3eff);
  font-family: var(--Typography-font-family, Montserrat);
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  transition: background 0.2s ease;
  cursor: pointer;
}

.secondary-button:hover:not(:disabled) {
  background: rgba(91, 62, 255, 0.08);
}

.secondary-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/PaymentStyles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB,EAAE,8BAA8B;EACtD,uBAAuB,EAAE,sBAAsB;EAC/C,mBAAmB,EAAE,wBAAwB;EAC7C,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,SAAS,EAAE,mDAAmD;AAChE;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,oCAAoC;EACpC,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,2CAA2C;EAC3C,sDAAsD;EACtD,+CAA+C;EAC/C,kBAAkB;EAClB,uDAAuD;EACvD,wDAAwD;AAC1D;;AAEA,qCAAqC;AACrC;EACE,2CAA2C;EAC3C,sDAAsD;EACtD,+CAA+C;EAC/C,kBAAkB;EAClB,wDAAwD;EACxD,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAE,kCAAkC;AAC9C;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;EAChD,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,mEAAmE;EACnE,0EAA0E;EAC1E,+CAA+C;EAC/C,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAE,2BAA2B;AACvC;;AAEA;EACE,SAAW;EACX,+CAA+C;EAC/C,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe,EAAE,uCAAuC;AAC1D;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;EACpE,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,qEAAqE;EACrE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB,EAAE,yBAAyB;AAChD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,sDAAsD;EACtD,+CAA+C;EAC/C,kBAAkB;EAClB,uDAAuD;EACvD,wDAAwD;AAC1D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,yCAAyC;EACzC,sDAAsD;EACtD,+CAA+C;EAC/C,wDAAwD;EACxD,wDAAwD;EACxD,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,yCAAyC;EACzC,sDAAsD;EACtD,+CAA+C;EAC/C,wDAAwD;EACxD,wDAAwD;EACxD,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAW;EACX,yCAAyC;;EAEzC,qBAAqB;EACrB,sDAAsD;EACtD,+CAA+C;EAC/C,kBAAkB;EAClB,wDAAwD;EACxD,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAW;EACX,2CAA2C;;EAE3C,sDAAsD;EACtD,+CAA+C;EAC/C,kBAAkB;EAClB,wDAAwD;EACxD,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,eAAe,EAAE,wBAAwB;EACzC,cAAc;EACd,kBAAkB;EAClB,iBAAiB,EAAE,sCAAsC;AAC3D;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,sDAAsD;EACtD,eAAe;EACf,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc,EAAE,aAAa;EAC7B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB,EAAE,aAAa;EACxC,sBAAsB;AACxB;;AAEA;EACE,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,cAAc,EAAE,YAAY;EAC5B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,cAAc,EAAE,YAAY;AAC9B;;AAEA;EACE,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,cAAc,EAAE,YAAY;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW,EAAE,kCAAkC;EAC/C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gCAAgC,EAAE,iCAAiC;EACnE,mCAAmC,EAAE,qCAAqC;EAC1E,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW,EAAE,wCAAwC;EACrD,UAAU,EAAE,2BAA2B;AACzC;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,oDAAoD;EACpD,WAAW;AACb;;AAEA;;EAEE,2CAA2C;EAC3C,oDAAoD;EACpD,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,kEAAkE;EAClE,+CAA+C;EAC/C,kBAAkB;EAClB,uDAAuD;EACvD,wDAAwD;EACxD,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,2CAA2C;;EAE3C,oBAAoB;EACpB,sDAAsD;EACtD,+CAA+C;EAC/C,kBAAkB;EAClB,uDAAuD;EACvD,wDAAwD,EAAE,aAAa;AACzE;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAW;EACX,kCAAkC;EAClC,sDAAsD;EACtD,+CAA+C;EAC/C,kBAAkB;EAClB,wDAAwD;EACxD,wDAAwD;EACxD,yBAAyB;EACzB,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;EACpE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;EACpE,eAAe;AACjB;;AAEA;EACE,qEAAqE;EACrE,8BAA8B;AAChC;;AAEA;EACE,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,yDAAyD;EACzD,kBAAkB;EAClB,sDAAsD;EACtD,+CAA+C;EAC/C,kBAAkB;EAClB,sDAAsD;EACtD,wDAAwD,EAAE,aAAa;AACzE;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,SAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,wBAAwB;EACxB,gBAAgB;EAChB,+CAA+C;EAC/C,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,8BAA8B;;AAEhC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;;AAGA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;AACA;+EAC+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,4EAA4E;EAC5E,+DAA+D;EAC/D,sDAAsD;EACtD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".payment-container {\n  display: flex;\n  flex-direction: column; /* Stack children vertically */\n  justify-content: center; /* Center vertically */\n  align-items: center; /* Center horizontally */\n  min-height: 100vh;\n  background-color: #f5f5f5;\n  padding: 20px;\n  gap: 40px; /* Adds consistent spacing between child elements */\n}\n\n.payment-card {\n  width: 70%;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 25px;\n  font-family: Arial, sans-serif;\n}\n\n.payment-header {\n  margin-bottom: 20px;\n}\n\n.payment-amount {\n  margin-bottom: 15px;\n}\n\n.amount-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  font-size: 16px;\n}\n\n.amount-row span:last-child {\n  font-weight: bold;\n}\n\n.payment-secured {\n  font-size: 16px;\n  color: #666;\n  text-align: right;\n}\n\n.divider {\n  height: 1px;\n  background-color: #eee;\n  margin: 20px 0;\n}\n\n.payment-method-title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.payment-methods {\n  margin-bottom: 25px;\n}\n\n.payment-form {\n  margin-top: 20px;\n}\n\n.form-title {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.card-details {\n  display: flex;\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.detail-group {\n  flex: 1;\n  margin-bottom: 50px;\n}\n\n.detail-group label {\n  display: block;\n  font-size: 14px;\n  margin-bottom: 5px;\n  color: #666;\n}\n\n.input-frame {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 10px;\n  height: 40px;\n}\n\n.save-card {\n  display: flex;\n  align-items: center;\n  margin: 20px 0;\n  font-size: 14px;\n}\n\n.save-card input {\n  margin-right: 10px;\n}\n\n.pay-button {\n  width: 100%;\n  background-color: #002b5b;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 12px;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.pay-button:hover {\n  background-color: #004494;\n}\n\n#paygreen-container,\n#paygreen-methods-container,\n#paygreen-pan-frame,\n#paygreen-cvv-frame,\n#paygreen-exp-frame {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  margin-bottom: 16px;\n}\n\n#paygreen-pan-frame {\n  margin-bottom: 15px;\n}\n\n.paygreen-pan-frame,\n.paygreen-cvv-frame,\n.paygreen-exp-frame {\n  background-color: rgb(243, 243, 243);\n  padding: 0 0.5rem;\n  border: none !important;\n  margin-bottom: 50px;\n}\n\n.paygreen-pan-frame:hover,\n.paygreen-cvv-frame:hover,\n.paygreen-exp-frame:hover {\n  border-bottom: 1px solid #5B3EFF !important;\n}\n\n.text-xl-semibold {\n  color: #191919;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n}\n\n/* Style pour le texte normal */\n.text-sm-regular {\n  color: var(--text-secondary-color, #37373b);\n  font-family: var(--Typography-font-family, montserrat);\n  font-size: var(--Typography-Size-Text-sm, 14px);\n  font-style: normal;\n  font-weight: var(--Typography-font-weight-regular, 400);\n  line-height: var(--Typography-line-height-Text-sm, 20px);\n}\n\n/* Style pour les mots en semi-bold */\n.text-sm-semibold {\n  color: var(--text-secondary-color, #37373b);\n  font-family: var(--Typography-font-family, montserrat);\n  font-size: var(--Typography-Size-Text-sm, 14px);\n  font-style: normal;\n  font-weight: var(--Typography-font-weight-semibold, 600);\n  line-height: var(--Typography-line-height-Text-sm, 20px);\n}\n\n.text-input-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px; /* Space between label and input */\n}\n\n.text-label {\n  align-self: stretch;\n  color: var(--Input-Label-Color-Default, #191919);\n  font-family: Montserrat, sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 0.28px;\n}\n\n.text-input {\n  display: flex;\n  padding: 8px 16px;\n  align-items: center;\n  align-self: stretch;\n  border-bottom: 1px solid var(--Input-Stroke-Color-Default, #5b3eff);\n  background: var(--Input-Background-Color-Default, rgba(91, 62, 255, 0.06));\n  color: var(--Input-Text-Color-Default, #191919);\n  border-radius: 0;\n  font-family: Montserrat, sans-serif;\n  font-size: 14px;\n}\n\n.text-input::placeholder {\n  color: var(--Input-Placeholder-Color-Default, #999999);\n  font-weight: 400;\n}\n\n.text-input:focus {\n  outline: none;\n  border-color: var(--Input-Stroke-Color-Default, #5b3eff);\n}\n\n.text-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px; /* Space between elements */\n}\n\n.email-help-message {\n  flex: 1 0 0;\n  color: var(--Input-Help-Color-Default, #37269a);\n  font-family: Montserrat, sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 13.6px;\n  letter-spacing: 0.24px;\n  margin-top: 4px; /* Small space above the help message */\n}\n\n.payment-button {\n  display: flex;\n  padding: 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n  border-radius: 8px;\n  background: var(--button-primaire-background-color-default, #5b3eff);\n  border: none;\n  color: white;\n  font-family: Montserrat, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  width: 100%;\n}\n\n.payment-button:hover:not(:disabled) {\n  background: var(--button-primaire-background-color-hover, #4a32d1);\n}\n\n.payment-button:disabled {\n  background: var(--button-primaire-background-color-disabled, #cccccc);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.custom-paygreen-frame {\n  margin-bottom: 12px; /* Space between fields */\n}\n\n.paygreen-frame {\n  width: 100% !important;\n  height: 48px !important;\n}\n\n.inputs-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.flex.gap-4 {\n  gap: 16px;\n}\n\n.payment-text {\n  align-self: stretch;\n  color: var(--text-secondary-color, #37373b);\n  text-align: center;\n  font-family: var(--Typography-font-family, montserrat);\n  font-size: var(--Typography-Size-Text-xs, 12px);\n  font-style: normal;\n  font-weight: var(--Typography-font-weight-regular, 400);\n  line-height: var(--Typography-line-height-Text-xs, 18px);\n}\n\n.payment-text strong {\n  font-weight: var(--Typography-font-weight-semibold, 600);\n}\n\n.auth-title {\n  color: var(--text-Display-color, #191919);\n  font-family: var(--Typography-font-family, montserrat);\n  font-size: var(--Typography-Size-Text-xl, 20px);\n  font-weight: var(--Typography-font-weight-semibold, 600);\n  line-height: var(--Typography-line-height-Text-xl, 30px);\n  text-align: center;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n.auth-title2 {\n  color: var(--text-Display-color, #191919);\n  font-family: var(--Typography-font-family, montserrat);\n  font-size: var(--Typography-Size-Text-xl, 20px);\n  font-weight: var(--Typography-font-weight-semibold, 400);\n  line-height: var(--Typography-line-height-Text-xl, 30px);\n  text-align: center;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.text-info-message {\n  flex: 1 0 0;\n  color: var(--text-Display-color, #191919);\n\n  /* Text md/Semibold */\n  font-family: var(--Typography-font-family, montserrat);\n  font-size: var(--Typography-Size-Text-md, 16px);\n  font-style: normal;\n  font-weight: var(--Typography-font-weight-semibold, 600);\n  line-height: var(--Typography-line-height-Text-md, 24px);\n}\n\n.icon-inline {\n  width: 20px;\n  height: 20px;\n  vertical-align: top;\n  margin-right: 4px;\n}\n\n.label-invoice {\n  flex: 1 0 0;\n  color: var(--text-secondary-color, #37373b);\n\n  font-family: var(--Typography-font-family, montserrat);\n  font-size: var(--Typography-Size-Text-sm, 14px);\n  font-style: normal;\n  font-weight: var(--Typography-font-weight-semibold, 600);\n  line-height: var(--Typography-line-height-Text-sm, 20px);\n}\n\n.custom-checkbox {\n  width: 20px;\n  height: 20px;\n  background: var(--cards-background-hover, #f3f0ff);\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  appearance: none;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: -10%;\n}\n\n/* Bigger violet checkmark */\n.custom-checkbox:checked::after {\n  content: \"✓\";\n  font-size: 14px; /* Increased from 12px */\n  color: #7e5bef;\n  position: absolute;\n  font-weight: bold; /* Optional: makes checkmark thicker */\n}\n\n.label-invoice {\n  margin-left: 18px;\n  color: var(--text-secondary-color, #37373b);\n  font-family: var(--Typography-font-family, montserrat);\n  font-size: 14px;\n  cursor: pointer;\n}\n\n/* Base styles */\n.input-group {\n  margin-top: 1rem;\n  width: 100%;\n}\n\n.input-label {\n  display: block;\n  color: #374151; /* gray-700 */\n  margin-bottom: 0.25rem;\n}\n\n.text-input {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #d1d5db; /* gray-300 */\n  border-radius: 0.25rem;\n}\n\n.text-input::placeholder {\n  color: #9ca3af; /* gray-400 */\n}\n\n.error-message {\n  color: #dc2626; /* red-600 */\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n}\n\n/* Error states */\n.input-label.error {\n  color: #dc2626; /* red-600 */\n}\n\n.text-input.input-error {\n  border-color: #dc2626; /* red-600 */\n}\n\n.text-input.input-error::placeholder {\n  color: #f87171; /* red-400 */\n}\n\n.input-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 4rem;\n}\n\n.input-label {\n  color: #000; /* Or your preferred label color */\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.styled-input {\n  display: flex;\n  padding: 8px 16px;\n  align-items: center;\n  align-self: stretch;\n  border: none;\n  border-bottom: 1px solid #5b3eff; /* --Input-Stroke-Color-Default */\n  background: rgba(91, 62, 255, 0.06); /* --Input-Background-Color-Default */\n  outline: none;\n  width: 100%;\n  color: #37373B;\n}\n\n.styled-input::placeholder {\n  color: #000; /* Or your preferred placeholder color */\n  opacity: 1; /* Ensure full visibility */\n}\n\n.paygreen-pan-frame {\n  border-bottom: 1px solid #5b3eff !important;\n  padding: 4px 16px !important;\n  background-color: rgba(91, 62, 255, 0.06) !important;\n  width: 100%;\n}\n\n.paygreen-cvv-frame,\n.paygreen-exp-frame {\n  border-bottom: 1px solid #5b3eff !important;\n  background-color: rgba(91, 62, 255, 0.06) !important;\n  padding: 4px 16px !important;\n  margin-top: 4px;\n}\n\n.error-title {\n  align-self: stretch;\n  color: #c40505;\n  text-align: center;\n  font-family: montserrat, sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 30px;\n  margin-bottom: 8px;\n}\n\n.displayed-error-message {\n  align-self: stretch;\n  color: var(--text-secondary-color, #37373b);\n  text-align: center;\n  font-family: var(--Typography-font-family, Montserrat), sans-serif;\n  font-size: var(--Typography-Size-Text-sm, 14px);\n  font-style: normal;\n  font-weight: var(--Typography-font-weight-regular, 400);\n  line-height: var(--Typography-line-height-Text-sm, 20px);\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 40px;\n}\n\n.displayed-error-message.mb-2 {\n  margin-bottom: 8px !important;\n}\n.displayed-message {\n  align-self: stretch;\n  color: var(--text-secondary-color, #37373b);\n\n  /* Text sm/Regular */\n  font-family: var(--Typography-font-family, Montserrat);\n  font-size: var(--Typography-Size-Text-sm, 14px);\n  font-style: normal;\n  font-weight: var(--Typography-font-weight-regular, 400);\n  line-height: var(--Typography-line-height-Text-sm, 20px); /* 142.857% */\n}\n.image-container {\n  width: 72px;\n  height: 72px;\n  margin-bottom: 40px;\n}\n\n.details-header {\n  flex: 1 0 0;\n  color: var(--Text-Highlight, #fff);\n  font-family: var(--Typography-font-family, Montserrat);\n  font-size: var(--Typography-Size-Text-sm, 14px);\n  font-style: normal;\n  font-weight: var(--Typography-font-weight-semibold, 600);\n  line-height: var(--Typography-line-height-Text-sm, 20px);\n  background-color: #5b3eff;\n  padding: 8px 16px;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n\n.details-container {\n  border-radius: 12px;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.details-content {\n  padding: 16px;\n  background-color: white;\n}\n\n.custom-button {\n  border-radius: 8px;\n  background: var(--button-primaire-background-color-default, #5b3eff);\n  display: flex;\n  padding: 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n  color: white;\n  font-weight: 600;\n  width: 100%;\n  transition: background 0.3s ease;\n  border: none;\n  margin-top: auto;\n}\n\n.custom-button:hover {\n  background: var(--button-primaire-background-color-default, #5b3eff);\n  cursor: pointer;\n}\n\n.disabled-button {\n  background: var(--button-primaire-background-color-disabled, #cccccc);\n  cursor: not-allowed !important;\n}\n\n.disabled-button:hover {\n  background: var(--button-primaire-background-color-disabled, #cccccc);\n  cursor: pointer;\n}\n\n.custom-button-text {\n  color: var(--button-primaire-content-color-default, #fff);\n  text-align: center;\n  font-family: var(--Typography-font-family, Montserrat);\n  font-size: var(--Typography-Size-Text-lg, 18px);\n  font-style: normal;\n  font-weight: var(--Typography-font-weight-medium, 500);\n  line-height: var(--Typography-line-height-Text-lg, 28px); /* 155.556% */\n}\n\n.small-btn {\n    width: 270px;\n    margin: auto;\n}\n\n.charging-containre {\n  display: flex;\n  max-width: 500px;\n  padding: 80px 0px;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n  flex: 1 0 0;\n  align-self: stretch;\n  border-radius: 8px;\n}\n\n.charging-image-container {\n  width: 64px;\n  height: 64px;\n  flex-shrink: 0;\n}\n\n.adress__card {\n  border: 1px solid var(--Stroke, #191919);\n  border-radius: 8px;\n  background-color: #FFFFFF;\n}\n\n.adress__card__header {\n  gap: 8px;\n  border-bottom-width: 1px;\n  padding: 2px 8px;\n  border-bottom: 1px solid var(--Stroke, #191919);\n  background: var(--Highlight-color, #5B3EFF);\n  color: #FFFFFF;\n}\n\n.available__card {\n  border: 2px solid var(--Highlight-color, #5B3EFF)\n}\n\n.noavailable__card {\n  border: 1px solid var(--carte-picto-texte-content-color, #191919)\n}\n\n.available__statusBar {\n  border-left: 8px solid #61D19D;\n\n}\n\n.noavailable__statusBar {\n  border-left: 8px solid #C40505;\n}\n\n/* Radio style large comme maquette */\n.custom-radio-wrapper {\n  position: relative;\n  width: 20px;\n  height: 20px;\n}\n\n.custom-radio-wrapper input[type=\"radio\"] {\n  opacity: 0;\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n\n.custom-radio {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  border: 1px solid #5B3EFF; \n  border-radius: 9999px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: white;\n  transition: all 0.2s ease;\n}\n\n.custom-radio-wrapper input[type=\"radio\"]:checked + .custom-radio {\n  background: #5B3EFF;\n  padding: 2px;\n  box-shadow: 0 0 0 2px rgba(108, 78, 255, 0.2);\n}\n\n\n.plug__text {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.status__text {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n\n.text-success-700 {\n  color: var(--Colors-Success-700, #37966A);\n}\n\n.text-error-700 {\n  color: var(--Colors-Error-700, #980404);\n}\n\n.pb-75 {\n  padding-bottom: 75px;\n}\n\n.mt-32 {\n  margin-top: 32px;\n}\n\n.footer-btn {\n  z-index: 1024;\n}\n\n.recaptcha-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.recaptcha-container > div {\n  transform: scale(0.9);\n  transform-origin: 0 0;\n  margin-bottom: 8px;\n}\n\n@media (min-width: 768px) {\n  .recaptcha-container > div {\n    transform: scale(1);\n  }\n}\n\n.styled-input .StripeElement {\n  padding: 8px 16px;\n  color: #37373B;\n  font-family: Montserrat, sans-serif;\n  font-size: 14px;\n  width: 100%;\n}\n\n.styled-input .StripeElement--invalid {\n  border-bottom: 1px solid red;\n}\n/* Action secondaire : volontairement plus discrete que .custom-button, pour ne\n   pas concurrencer le CTA principal de fin de recharge (deblocage du cable). */\n.secondary-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 8px;\n  background: transparent;\n  border: 1.5px solid var(--button-primaire-background-color-default, #5b3eff);\n  color: var(--button-primaire-background-color-default, #5b3eff);\n  font-family: var(--Typography-font-family, Montserrat);\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22px;\n  transition: background 0.2s ease;\n  cursor: pointer;\n}\n\n.secondary-button:hover:not(:disabled) {\n  background: rgba(91, 62, 255, 0.08);\n}\n\n.secondary-button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
